import React, { useState } from "react"
import * as styles from "./PostArchive.module.scss"
import { getRecords } from "@data/datocms"
import { datoModels } from "@data/static"
import Breadcrumbs from "@components/global/Breadcrumbs/Breadcrumbs"
import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import BlogIntro from "@components/layouts/blog/BlogIntro/BlogIntro"
import PostsList from "@components/layouts/blog/PostsList/PostsList"
import Button from "@components/objects/Button/Button"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const PostArchive = ({ initialPosts, totalPosts }) => {
  const [loadedPosts, setLoadedPosts] = useState(initialPosts)
  const [isLoading, setIsLoading] = useState(!initialPosts.length)
  const [orderParam, setOrderParam] = useState({ order: "DESC", orderBy: "publishedDate" })

  const loadMore = async () => {
    setIsLoading(true)
    const { order, orderBy } = orderParam
    const { records } = await getRecords(datoModels.POST, initialPosts.length, loadedPosts.length, orderBy, order)
    setLoadedPosts([...loadedPosts, ...records])
    setIsLoading(false)
  }

  const handleSort = async (selectedOption) => {
    const { order, orderBy } = JSON.parse(selectedOption.value)
    setOrderParam({ order, orderBy })
    setIsLoading(true)
    setLoadedPosts([])
    const { records } = await getRecords(datoModels.POST, initialPosts.length, 0, orderBy, order)
    setLoadedPosts(records)
    setIsLoading(false)
  }

  return (
    <div className={styles.PostArchive}>
      <SiteWrapper>
        <Breadcrumbs color="blue" linkColor="grey" elements={["Top Tips"]} />
        <BlogIntro
          title="TOP OF THE HOPPS"
          description="The latest Party knowledge from the HOPP experts"
          handleSort={handleSort}
        />
        <PostsList posts={loadedPosts} />
        {isLoading && <FetchSpinner />}
        {!isLoading && loadedPosts?.length < totalPosts && (
          <div className={styles.buttons}>
            <Button text="Load More" design="outline" color="dark" onClick={() => loadMore()} />
          </div>
        )}
      </SiteWrapper>
    </div>
  )
}

export default PostArchive
